const Admin = 'Employee'
const Client = 'Client'
const Partner = 'Partner'
const Sac = 'Sac'
const SacUp = 'SACUP'
const Financial = 'Financial'
const PublicBody = 'Public Body'
const Requester = 'Requester'
export const RoleConstants = {
	Admin,
	Client,
	Partner,
	Sac,
	SacUp,
	Financial,
	PublicBody,
	Requester,
}
